<h1 mat-dialog-title>Tierreklamation hinzuf&uuml;gen</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-reklamieren
        #reklamieren
        [dialog]="true"
        [tier]="tier"
        (saved)="dialogRef.close(reklamieren.tier)"
    >
        <ng-container additional-actions>
            <button type="button" mat-flat-button class="reklamieren-abort-button" (click)="dialogRef.close()">
                Abbrechen
            </button>
        </ng-container>
    </kiene-gruppe-tier-reklamieren>
</div>
